import React, { useEffect } from "react";
import flowRight from "lodash/flowRight";
import withFocus from "pages/_components/withFocus";
import formField from "pages/forms/_components/_fields/_commons/formField";
import NumberFormat from "react-number-format";
import * as numberUtils from "util/number";
import FormattedAmount from "pages/_components/FormattedAmount";
import { func, shape, string } from "prop-types";

const INPUT_REGEX_REPLACE = /[^0-9.,]/g;

const NumberField = ({
    mode,
    idField,
    onBlur,
    decimalSeparator,
    precision,
    setValue,
    value,
    placeholder = "",
    thousandsSeparator,
    toggleIsFocused,
}) => {
    useEffect(() => {
        setValue("");
    }, [setValue]);

    let quantityRef = null;

    const handleChange = () => {
        let quantity = quantityRef.value.replace(INPUT_REGEX_REPLACE, "");
        quantity = numberUtils.toNumber(quantity, decimalSeparator, precision);
        setValue(quantity);
    };

    const renderViewMode = () => <FormattedAmount {...value} />;

    const renderEditMode = () => (
        <div className="input-group" onFocus={toggleIsFocused} onBlur={toggleIsFocused}>
            <NumberFormat
                id={idField}
                name="quantity"
                className="form-control text-right"
                type="text"
                onBlur={onBlur}
                onChange={() => {
                    handleChange();
                }}
                maxLength="20"
                value={value}
                placeholder={placeholder}
                getInputRef={(ref) => {
                    quantityRef = ref;
                }}
                decimalScale={precision}
                thousandSeparator={thousandsSeparator}
                decimalSeparator={decimalSeparator}
                fixedDecimalScale
            />
        </div>
    );
    return <>{mode === "edit" ? renderEditMode() : renderViewMode()}</>;
};

NumberField.propTypes = {
    setValue: func,
    value: shape({}).isRequired,
    onBlur: func,
    idField: string.isRequired,
    decimalSeparator: string,
    precision: string,
    mode: string,
    placeholder: string,
    thousandsSeparator: string,
    toggleIsFocused: string,
};
NumberField.defaultProps = {
    decimalSeparator: "",
    onBlur: () => {},
    setValue: () => {},
    precision: "",
    mode: "",
    placeholder: "",
    thousandsSeparator: "",
    toggleIsFocused: "",
};

export default flowRight(withFocus, formField())(NumberField);
